import { render, staticRenderFns } from "./moment.vue?vue&type=template&id=2d9b2c68&scoped=true"
import script from "./moment.vue?vue&type=script&lang=js"
export * from "./moment.vue?vue&type=script&lang=js"
import style0 from "./moment.vue?vue&type=style&index=0&id=2d9b2c68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b2c68",
  null
  
)

export default component.exports